import React from "react";

import { Button, Container, Row, Col } from "reactstrap";

// core components
import SolNavbar from "components/Navbars/SolNavbar.js";
import SolFooter from "components/Footers/SolFooter.js";
import UnsettledBannerImg from "assets/img/flyers/unsettled_banner.png";
import UnsettledWorkshopPdf from "assets/img/flyers/unsettled_workshop.pdf";

function Events() {
  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");

    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  return (
    <>
      <SolNavbar />
      <div style={{ color: "black", paddingTop: 100, marginBottom: 100 }}>
        <Container>
          <div style={{ textAlign: "left" }}>
            <Row>
              <Col md='12'>
                <div>
                  <img
                    src={UnsettledBannerImg}
                    alt='Unsettled workshop banner'
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block",
                    }}
                  />
                  <div style={{ float: "right" }}>
                    <Button
                      color='info'
                      href={UnsettledWorkshopPdf}
                      target='_blank'
                    >
                      Download Flyer
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md='12'>
                <div>
                  <div style={{ float: "left" }}>
                    <h3 style={{ color: "purple" }}>
                      *** Registration is now closed. ***
                    </h3>
                  </div>
                  {/* <div style={{ float: "left", paddingTop: 5, marginLeft: 10 }}>
                    <span
                      style={{
                        fontWeight: "bold",
                        color: "red",
                        fontSize: 18,
                        fontStyle: "italic",
                      }}
                    >
                      Early-bird pricing has been extended!
                    </span>
                  </div> */}
                </div>
              </Col>
            </Row>
            {/* <Row>
              <Col md='3'>
                <FormGroup>
                  <Label>First Name</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        firstName: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.firstName ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your first name.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='3'>
                <FormGroup>
                  <Label>Last Name</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        lastName: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.lastName ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your last name.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='2'>
                <FormGroup>
                  <Label>Birth Year</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        birthYear: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.birthYear ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your birth year.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='4'>
                <FormGroup>
                  <Label>Phone</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        phone: e.target.value,
                      })
                    }
                  ></Input>
                  {submitting && !registration.phone ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your phone number.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md='6'>
                <FormGroup>
                  <Label>Email Address</Label>
                  <Input
                    defaultValue=''
                    type='email'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        email: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.email ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your email address.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='6'>
                <FormGroup>
                  <Label>Confirm Email Address</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        emailConfirm: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting &&
                  registration.email !== registration.emailConfirm ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Email addresses don't match.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md='8'>
                <FormGroup>
                  <Label>Address</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        address: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.address ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your address.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='4'>
                <FormGroup>
                  <Label>Address 2</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        address2: e.target.value,
                      })
                    }
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md='6'>
                <FormGroup>
                  <Label>City</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        city: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.city ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your city.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='2'>
                <FormGroup>
                  <Label>State</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        state: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.state ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your state.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='4'>
                <FormGroup>
                  <Label>Zip Code</Label>
                  <Input
                    defaultValue=''
                    type='text'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        zip: e.target.value,
                      })
                    }
                    required
                  ></Input>
                  {submitting && !registration.zip ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your zip code.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md='4'>
                <FormGroup>
                  <Label>Dietary Preferences or Restrictions?</Label>
                  <Input
                    defaultValue=''
                    type='textarea'
                    style={{
                      border: "1px solid #e3e3e3",
                      borderRadius: "30px",
                    }}
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        dietary: e.target.value,
                      })
                    }
                  ></Input>
                </FormGroup>
              </Col>
              <Col md='4'>
                <FormGroup>
                  <Label>Goal or Purpose in Attending this Workshop?</Label>
                  <Input
                    defaultValue=''
                    type='textarea'
                    style={{
                      border: "1px solid #e3e3e3",
                      borderRadius: "30px",
                    }}
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        goal: e.target.value,
                      })
                    }
                  ></Input>
                </FormGroup>
              </Col>
              <Col md='4'>
                <FormGroup>
                  <Label>How’d You Hear About Us?</Label>
                  <Input
                    defaultValue=''
                    type='textarea'
                    style={{
                      border: "1px solid #e3e3e3",
                      borderRadius: "30px",
                    }}
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        howdYouHear: e.target.value,
                      })
                    }
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md='3'>
                <FormGroup>
                  <Label for='exampleSelect'>Payment Method</Label>
                  <Input
                    id='exampleSelect'
                    name='select'
                    type='select'
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        payment: e.target.value,
                      })
                    }
                  >
                    <option>-- please select --</option>
                    <option>Debit/Credit Card</option>
                    <option>Check</option>
                  </Input>
                  {submitting &&
                  (registration.payment === "-- please select --" ||
                    registration.payment === "") ? (
                    <div
                      style={{
                        color: "red",
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      * Please enter your method of payment.
                    </div>
                  ) : null}
                </FormGroup>
              </Col>
              <Col md='9'>
                <FormGroup>
                  <Label>Additional Notes?</Label>
                  <Input
                    defaultValue=''
                    type='textarea'
                    style={{
                      border: "1px solid #e3e3e3",
                      borderRadius: "30px",
                    }}
                    onChange={(e) =>
                      setRegistration({
                        ...registration,
                        notes: e.target.value,
                      })
                    }
                    required
                  ></Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md='12'>
                <span style={{ fontStyle: "italic", fontWeight: "bold" }}>
                  **Registration is considered complete upon receipt of full
                  payment and subsequent confirmation via email from The Sol
                  Institute, LLC.
                </span>
              </Col>
            </Row>

            <Row>
              <Col>
                <Button color='info' onClick={saveRegistration}>
                  Register
                </Button>
              </Col>
            </Row> */}
          </div>
        </Container>
      </div>
      <SolFooter />
    </>
  );
}

export default Events;
